import { useSelector } from 'react-redux';

import { bankDepositCountSelector } from './selectors';

export function useGetBankDepositCount() {
  return useSelector(bankDepositCountSelector);
}
